import { render, staticRenderFns } from "./PrivilegeSetList.vue?vue&type=template&id=5d0705df&scoped=true"
import script from "./PrivilegeSetList.vue?vue&type=script&lang=js"
export * from "./PrivilegeSetList.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeSetList.vue?vue&type=style&index=0&id=5d0705df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0705df",
  null
  
)

export default component.exports